<template>
  <div class="page-home">
    <ic-banner-list :data="bannerList"></ic-banner-list>
    <div class="se">
      <div class="g-wrap">
        <div class="column-wrap">
          <!-- <main-entrance-card></main-entrance-card> -->
          <Entrance />
        </div>
      </div>
    </div>
    <div class="g-wrap news-wrap">
      <div class="news">
        <column-header :data="newsColumn"></column-header>
        <div class="column-wrap">
          <ic-slide-news :data="slideNews"></ic-slide-news>
          <ic-news :data="topNews"></ic-news>
        </div>
      </div>
      <div class="notice">
        <column-header :data="noticeColumn"></column-header>
        <div class="column-wrap">
          <ic-news :data="noticeNews" type="calendar"></ic-news>
        </div>
      </div>
    </div>
    <div class="ic">
      <div class="g-wrap">
        <column-header :data="icColumn"></column-header>
        <div class="column-wrap">
          <ic-card :data="item" :key="i" v-for="(item, i) in icList"></ic-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import ColumnHeader from "_c/ColumnHeader";
import SlideNews from "_c/SlideNews";
import News from "_c/News";
import Card from "_c/IcCard";
import BannerList from "_c/BannerList";
import SeCard from "_c/MainSeCard";
import Entrance from "_c/Entrance.vue";
export default {
  data() {
    return {
      newsColumn: {
        name: "新闻资讯",
        enName: "News",
        link: "/portal/column/news"
      },
      noticeColumn: {
        name: "通知公告",
        enName: "Notice",
        link: "/portal/column/notice"
      },
      icColumn: {
        name: "产业学院",
        enName: "Industry College",
        link: "/portal/college"
      },
      Entrance: {
        name: "系统入口",
        enName: "System Entrance",
        linl: ""
      },
      bannerList: [],
      slideNews: [],
      topNews: [],
      noticeNews: [],
      icList: []
    };
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    [SlideNews.name]: SlideNews,
    [News.name]: News,
    [Card.name]: Card,
    [BannerList.name]: BannerList,
    [SeCard.name]: SeCard,
    Entrance
  },
  methods: {
    loadBanner() {
      getData({ name: "SchoolBanner" }).then(res => {
        this.bannerList = res || [];
      });
    },
    loadSlideNews() {
      getData({
        name: "SchoolNews",
        top: 5,
        params: [{ Key: "Illustration", Value: "", CompareType: "NotEqualTo" }]
      }).then(res => {
        this.slideNews = (res || []).map(item => {
          item.link = "/portal/detail/SchoolNews?id=" + item.Id;
          return item;
        });
      });
    },
    loadTopNews() {
      getData({ name: "SchoolNews", top: 4 }).then(res => {
        this.topNews = (res || []).map(item => {
          item.link = "/portal/detail/SchoolNews?id=" + item.Id;
          return item;
        });
      });
    },
    loadNoticeNews() {
      getData({ name: "Announcement", top: 4 }).then(res => {
        this.noticeNews = (res || []).map(item => {
          item.link = "/portal/detail/Announcement?id=" + item.Id;
          return item;
        });
      });
    },
    loadICList() {
      getData({ name: "College" }).then(res => {
        this.icList = res || [];
      });
    },
    init() {
      this.loadBanner();
      this.loadSlideNews();
      this.loadTopNews();
      this.loadNoticeNews();
      this.loadICList();
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.page-home {
  .banner {
    ::v-deep .el-carousel {
      margin: 0 auto;
      text-align: center;
    }
    ::v-deep .el-carousel__button {
      height: 6px;
      opacity: 1;
    }
    ::v-deep .el-carousel__item {
      img {
        height: 100%;
        width: auto;
      }
    }
    ::v-deep .el-carousel__indicator.is-active {
      .el-carousel__button {
        background-color: $primary-color;
      }
    }
  }
  .column-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .news-wrap {
    display: flex;
    @include clearfix();
    padding-bottom: 40px;
    .news {
      margin-right: 24px;
    }
    .comp-slide-news {
      width: 376px;
      margin-right: 24px;
      height: 266px;
    }
    .comp-news {
      width: 376px;
      height: 266px;
    }
  }
  .notice {
    width: 376px;
  }
  .ic {
    background: url(~assets/img/portal/ic-bg.png) no-repeat left bottom #eaecf3;
    padding-bottom: 30px;
    ::v-deep .comp-ic-card {
      margin: 0 23px 16px 0;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .se {
    background: #f6f6f9;
    width: 100%;
  }
}
</style>
